var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "f7-page",
    {
      staticClass: "no-swipeback",
      attrs: { id: "register-screen" },
      on: { "popup:open": function ($event) {} },
    },
    [
      _c(
        "div",
        { staticClass: "body", style: _vm.bgRegister },
        [
          _c("b-row", { staticStyle: { height: "100%" } }, [
            _c("div", { staticClass: "loginPanel loginHeight" }, [
              _c(
                "div",
                [
                  _c(
                    "div",
                    { staticClass: "panel-heading ajust text-center" },
                    [
                      _c("h4", { staticClass: "panel-title" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("common.rgstr")) +
                            "\n            "
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-tabs",
                    { staticClass: "ml-3 mt-4" },
                    [
                      _c(
                        "b-tab",
                        {
                          attrs: {
                            title: _vm.$t("common.indiv"),
                            "tab-link": ".tabIndividual",
                            active: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.changeCurrentRole("individual")
                            },
                          },
                        },
                        [
                          _c(
                            "b-row",
                            { staticClass: "mt-4" },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "form-group",
                                  attrs: { cols: "8", offset: "2" },
                                },
                                [
                                  _c("label", [_vm._v("Prénom")]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-control",
                                      staticStyle: {
                                        display: "flex",
                                        height: "40px",
                                      },
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.firstName_r,
                                            expression: "firstName_r",
                                          },
                                        ],
                                        staticStyle: {
                                          border: "none",
                                          width: "100%",
                                        },
                                        attrs: {
                                          inputType: "text",
                                          placeholder: _vm.register_FirstName,
                                        },
                                        domProps: { value: _vm.firstName_r },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.firstName_r =
                                              $event.target.value
                                          },
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "form-group",
                                  attrs: { cols: "8", offset: "2" },
                                },
                                [
                                  _c("label", [_vm._v("Nom de famille")]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-control",
                                      staticStyle: {
                                        display: "flex",
                                        height: "40px",
                                      },
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.LastName_r,
                                            expression: "LastName_r",
                                          },
                                        ],
                                        staticStyle: {
                                          border: "none",
                                          width: "100%",
                                        },
                                        attrs: {
                                          inputType: "text",
                                          placeholder: _vm.register_LastName,
                                        },
                                        domProps: { value: _vm.LastName_r },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.LastName_r = $event.target.value
                                          },
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "form-group",
                                  attrs: { cols: "8", offset: "2" },
                                },
                                [
                                  _c("label", [_vm._v("Email")]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-control",
                                      staticStyle: {
                                        display: "flex",
                                        height: "40px",
                                      },
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.email_r,
                                            expression: "email_r",
                                          },
                                        ],
                                        staticStyle: {
                                          border: "none",
                                          width: "100%",
                                        },
                                        attrs: {
                                          inputType: "email",
                                          placeholder: _vm.register_Email,
                                        },
                                        domProps: { value: _vm.email_r },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.email_r = $event.target.value
                                          },
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "form-group",
                                  attrs: { cols: "8", offset: "2" },
                                },
                                [
                                  _c("form-dropdown-input", {
                                    attrs: {
                                      inputType: "text",
                                      placeholderValue:
                                        _vm.$t("common.enter_ctry"),
                                      itemList: _vm.country,
                                      customHeight: 40,
                                      inputLabel: "Pays",
                                    },
                                    model: {
                                      value: _vm.country_r,
                                      callback: function ($$v) {
                                        _vm.country_r = $$v
                                      },
                                      expression: "country_r",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.displayPassword
                            ? _c(
                                "b-row",
                                { attrs: { required: "" } },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "form-group",
                                      attrs: { cols: "8", offset: "2" },
                                    },
                                    [
                                      _c("label", [_vm._v("Mot de passe")]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "form-control passwordControl",
                                          staticStyle: {
                                            display: "flex",
                                            height: "40px",
                                          },
                                        },
                                        [
                                          _vm.passwordFieldType === "checkbox"
                                            ? _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.password1_r,
                                                    expression: "password1_r",
                                                  },
                                                ],
                                                staticStyle: {
                                                  border: "none",
                                                  width: "100%",
                                                },
                                                attrs: {
                                                  placeholder:
                                                    _vm.register_Password,
                                                  autocomplete: "new-password",
                                                  type: "checkbox",
                                                },
                                                domProps: {
                                                  checked: Array.isArray(
                                                    _vm.password1_r
                                                  )
                                                    ? _vm._i(
                                                        _vm.password1_r,
                                                        null
                                                      ) > -1
                                                    : _vm.password1_r,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    var $$a = _vm.password1_r,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v = null,
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          (_vm.password1_r =
                                                            $$a.concat([$$v]))
                                                      } else {
                                                        $$i > -1 &&
                                                          (_vm.password1_r = $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            ))
                                                      }
                                                    } else {
                                                      _vm.password1_r = $$c
                                                    }
                                                  },
                                                },
                                              })
                                            : _vm.passwordFieldType === "radio"
                                            ? _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.password1_r,
                                                    expression: "password1_r",
                                                  },
                                                ],
                                                staticStyle: {
                                                  border: "none",
                                                  width: "100%",
                                                },
                                                attrs: {
                                                  placeholder:
                                                    _vm.register_Password,
                                                  autocomplete: "new-password",
                                                  type: "radio",
                                                },
                                                domProps: {
                                                  checked: _vm._q(
                                                    _vm.password1_r,
                                                    null
                                                  ),
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    _vm.password1_r = null
                                                  },
                                                },
                                              })
                                            : _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.password1_r,
                                                    expression: "password1_r",
                                                  },
                                                ],
                                                staticStyle: {
                                                  border: "none",
                                                  width: "100%",
                                                },
                                                attrs: {
                                                  placeholder:
                                                    _vm.register_Password,
                                                  autocomplete: "new-password",
                                                  type: _vm.passwordFieldType,
                                                },
                                                domProps: {
                                                  value: _vm.password1_r,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.password1_r =
                                                      $event.target.value
                                                  },
                                                },
                                              }),
                                          _vm._v(" "),
                                          _c("i", {
                                            staticClass:
                                              "icon icon-password mt-2",
                                            class: [
                                              _vm.isPasswordFieldHidden
                                                ? "fa-duotone fa-eye"
                                                : "fa-duotone fa-eye-slash",
                                            ],
                                            on: { click: _vm.toggleVisibility },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.displayPassword
                            ? _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "form-group",
                                      attrs: { cols: "8", offset: "2" },
                                    },
                                    [
                                      _c("label", [
                                        _vm._v("Répéter le mot de passe"),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "form-control passwordControl",
                                          staticStyle: {
                                            display: "flex",
                                            height: "40px",
                                          },
                                        },
                                        [
                                          _vm.passwordFieldType_2 === "checkbox"
                                            ? _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.password2_r,
                                                    expression: "password2_r",
                                                  },
                                                ],
                                                staticStyle: {
                                                  border: "none",
                                                  width: "100%",
                                                },
                                                attrs: {
                                                  placeholder:
                                                    _vm.register_RepeatPassword,
                                                  type: "checkbox",
                                                },
                                                domProps: {
                                                  checked: Array.isArray(
                                                    _vm.password2_r
                                                  )
                                                    ? _vm._i(
                                                        _vm.password2_r,
                                                        null
                                                      ) > -1
                                                    : _vm.password2_r,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    var $$a = _vm.password2_r,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v = null,
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          (_vm.password2_r =
                                                            $$a.concat([$$v]))
                                                      } else {
                                                        $$i > -1 &&
                                                          (_vm.password2_r = $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            ))
                                                      }
                                                    } else {
                                                      _vm.password2_r = $$c
                                                    }
                                                  },
                                                },
                                              })
                                            : _vm.passwordFieldType_2 ===
                                              "radio"
                                            ? _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.password2_r,
                                                    expression: "password2_r",
                                                  },
                                                ],
                                                staticStyle: {
                                                  border: "none",
                                                  width: "100%",
                                                },
                                                attrs: {
                                                  placeholder:
                                                    _vm.register_RepeatPassword,
                                                  type: "radio",
                                                },
                                                domProps: {
                                                  checked: _vm._q(
                                                    _vm.password2_r,
                                                    null
                                                  ),
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    _vm.password2_r = null
                                                  },
                                                },
                                              })
                                            : _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.password2_r,
                                                    expression: "password2_r",
                                                  },
                                                ],
                                                staticStyle: {
                                                  border: "none",
                                                  width: "100%",
                                                },
                                                attrs: {
                                                  placeholder:
                                                    _vm.register_RepeatPassword,
                                                  type: _vm.passwordFieldType_2,
                                                },
                                                domProps: {
                                                  value: _vm.password2_r,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.password2_r =
                                                      $event.target.value
                                                  },
                                                },
                                              }),
                                          _vm._v(" "),
                                          _c("i", {
                                            staticClass:
                                              "icon icon-password mt-2",
                                            class: [
                                              _vm.isPasswordFieldHidden_2
                                                ? "fa-duotone fa-eye"
                                                : "fa-duotone fa-eye-slash",
                                            ],
                                            on: {
                                              click: _vm.toggleVisibility_2,
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-tab",
                        {
                          attrs: {
                            "tab-link": ".tabProfessional",
                            title: _vm.$t("common.busnss"),
                          },
                          on: {
                            click: function ($event) {
                              return _vm.changeCurrentRole("professional")
                            },
                          },
                        },
                        [
                          _c(
                            "b-row",
                            { staticClass: "mt-4" },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "form-group",
                                  attrs: { cols: "8", offset: "2" },
                                },
                                [
                                  _c("label", [_vm._v("Nom de l'entreprise")]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-control",
                                      staticStyle: {
                                        display: "flex",
                                        height: "40px",
                                      },
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.companyName_r,
                                            expression: "companyName_r",
                                          },
                                        ],
                                        staticStyle: {
                                          border: "none",
                                          width: "100%",
                                        },
                                        attrs: {
                                          inputType: "text",
                                          placeholder: _vm.register_CompanyName,
                                        },
                                        domProps: { value: _vm.companyName_r },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.companyName_r =
                                              $event.target.value
                                          },
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "form-group",
                                  attrs: { cols: "8", offset: "2" },
                                },
                                [
                                  _c("label", [
                                    _vm._v("Numéro de l'entreprise"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-control",
                                      staticStyle: {
                                        display: "flex",
                                        height: "40px",
                                      },
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.companyNumber_r,
                                            expression: "companyNumber_r",
                                          },
                                        ],
                                        staticStyle: {
                                          border: "none",
                                          width: "100%",
                                        },
                                        attrs: {
                                          inputType: "text",
                                          placeholder:
                                            _vm.register_CompanyNumber,
                                        },
                                        domProps: {
                                          value: _vm.companyNumber_r,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.companyNumber_r =
                                              $event.target.value
                                          },
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "form-group",
                                  attrs: { cols: "8", offset: "2" },
                                },
                                [
                                  _c("label", [_vm._v("Email")]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-control",
                                      staticStyle: {
                                        display: "flex",
                                        height: "40px",
                                      },
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.email_r,
                                            expression: "email_r",
                                          },
                                        ],
                                        staticStyle: {
                                          border: "none",
                                          width: "100%",
                                        },
                                        attrs: {
                                          inputType: "email",
                                          placeholder: _vm.register_Email,
                                        },
                                        domProps: { value: _vm.email_r },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.email_r = $event.target.value
                                          },
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "form-group",
                                  attrs: { cols: "8", offset: "2" },
                                },
                                [
                                  _c("form-dropdown-input", {
                                    attrs: {
                                      inputType: "text",
                                      placeholderValue:
                                        _vm.$t("common.enter_ctry"),
                                      itemList: _vm.country,
                                      customHeight: 40,
                                      inputLabel: "Pays",
                                    },
                                    model: {
                                      value: _vm.country_r,
                                      callback: function ($$v) {
                                        _vm.country_r = $$v
                                      },
                                      expression: "country_r",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.displayPassword
                            ? _c(
                                "b-row",
                                { attrs: { required: "" } },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "form-group",
                                      attrs: { cols: "8", offset: "2" },
                                    },
                                    [
                                      _c("label", [_vm._v("Mot de passe")]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "form-control passwordControl",
                                          staticStyle: {
                                            display: "flex",
                                            height: "40px",
                                          },
                                        },
                                        [
                                          _vm.passwordFieldType_3 === "checkbox"
                                            ? _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.password1_r,
                                                    expression: "password1_r",
                                                  },
                                                ],
                                                staticStyle: {
                                                  border: "none",
                                                  width: "100%",
                                                },
                                                attrs: {
                                                  placeholder:
                                                    _vm.register_Password,
                                                  type: "checkbox",
                                                },
                                                domProps: {
                                                  checked: Array.isArray(
                                                    _vm.password1_r
                                                  )
                                                    ? _vm._i(
                                                        _vm.password1_r,
                                                        null
                                                      ) > -1
                                                    : _vm.password1_r,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    var $$a = _vm.password1_r,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v = null,
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          (_vm.password1_r =
                                                            $$a.concat([$$v]))
                                                      } else {
                                                        $$i > -1 &&
                                                          (_vm.password1_r = $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            ))
                                                      }
                                                    } else {
                                                      _vm.password1_r = $$c
                                                    }
                                                  },
                                                },
                                              })
                                            : _vm.passwordFieldType_3 ===
                                              "radio"
                                            ? _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.password1_r,
                                                    expression: "password1_r",
                                                  },
                                                ],
                                                staticStyle: {
                                                  border: "none",
                                                  width: "100%",
                                                },
                                                attrs: {
                                                  placeholder:
                                                    _vm.register_Password,
                                                  type: "radio",
                                                },
                                                domProps: {
                                                  checked: _vm._q(
                                                    _vm.password1_r,
                                                    null
                                                  ),
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    _vm.password1_r = null
                                                  },
                                                },
                                              })
                                            : _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.password1_r,
                                                    expression: "password1_r",
                                                  },
                                                ],
                                                staticStyle: {
                                                  border: "none",
                                                  width: "100%",
                                                },
                                                attrs: {
                                                  placeholder:
                                                    _vm.register_Password,
                                                  type: _vm.passwordFieldType_3,
                                                },
                                                domProps: {
                                                  value: _vm.password1_r,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.password1_r =
                                                      $event.target.value
                                                  },
                                                },
                                              }),
                                          _vm._v(" "),
                                          _c("i", {
                                            staticClass:
                                              "icon icon-password mt-2",
                                            class: [
                                              _vm.isPasswordFieldHidden_3
                                                ? "fa-duotone fa-eye"
                                                : "fa-duotone fa-eye-slash",
                                            ],
                                            on: {
                                              click: _vm.toggleVisibility_3,
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.displayPassword
                            ? _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "form-group",
                                      attrs: { cols: "8", offset: "2" },
                                    },
                                    [
                                      _c("label", [
                                        _vm._v("Répéter le mot de passe"),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "form-control passwordControl",
                                          staticStyle: {
                                            display: "flex",
                                            height: "40px",
                                          },
                                        },
                                        [
                                          _vm.passwordFieldType_4 === "checkbox"
                                            ? _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.password2_r,
                                                    expression: "password2_r",
                                                  },
                                                ],
                                                staticStyle: {
                                                  border: "none",
                                                  width: "100%",
                                                },
                                                attrs: {
                                                  placeholder:
                                                    _vm.register_RepeatPassword,
                                                  type: "checkbox",
                                                },
                                                domProps: {
                                                  checked: Array.isArray(
                                                    _vm.password2_r
                                                  )
                                                    ? _vm._i(
                                                        _vm.password2_r,
                                                        null
                                                      ) > -1
                                                    : _vm.password2_r,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    var $$a = _vm.password2_r,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v = null,
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          (_vm.password2_r =
                                                            $$a.concat([$$v]))
                                                      } else {
                                                        $$i > -1 &&
                                                          (_vm.password2_r = $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            ))
                                                      }
                                                    } else {
                                                      _vm.password2_r = $$c
                                                    }
                                                  },
                                                },
                                              })
                                            : _vm.passwordFieldType_4 ===
                                              "radio"
                                            ? _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.password2_r,
                                                    expression: "password2_r",
                                                  },
                                                ],
                                                staticStyle: {
                                                  border: "none",
                                                  width: "100%",
                                                },
                                                attrs: {
                                                  placeholder:
                                                    _vm.register_RepeatPassword,
                                                  type: "radio",
                                                },
                                                domProps: {
                                                  checked: _vm._q(
                                                    _vm.password2_r,
                                                    null
                                                  ),
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    _vm.password2_r = null
                                                  },
                                                },
                                              })
                                            : _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.password2_r,
                                                    expression: "password2_r",
                                                  },
                                                ],
                                                staticStyle: {
                                                  border: "none",
                                                  width: "100%",
                                                },
                                                attrs: {
                                                  placeholder:
                                                    _vm.register_RepeatPassword,
                                                  type: _vm.passwordFieldType_4,
                                                },
                                                domProps: {
                                                  value: _vm.password2_r,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.password2_r =
                                                      $event.target.value
                                                  },
                                                },
                                              }),
                                          _vm._v(" "),
                                          _c("i", {
                                            staticClass:
                                              "icon icon-password mt-2",
                                            class: [
                                              _vm.isPasswordFieldHidden_4
                                                ? "fa-duotone fa-eye"
                                                : "fa-duotone fa-eye-slash",
                                            ],
                                            on: {
                                              click: _vm.toggleVisibility_4,
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "loginButtons" },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "8", offset: "2" } },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "primary", size: "lg" },
                              on: {
                                click: function ($event) {
                                  return _vm.registerNewUser()
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.$t("common.rgstr")) +
                                  "\n              "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "loginButtons pt-3" },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "8", offset: "2" } },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "loginGoogleButton btn",
                              attrs: { size: "lg" },
                              on: {
                                click: function ($event) {
                                  return _vm.goBack()
                                },
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "vertical-align": "middle",
                                    "font-size": "13px",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.$t("common.bck")) +
                                      "\n                "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "picker-modal countryListPicker" }, [
                    _c("div", { staticClass: "toolbar" }, [
                      _c("div", { staticClass: "toolbar-inner" }, [
                        _c("div", { staticClass: "left" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "right" }, [
                          _c(
                            "a",
                            {
                              staticClass: "close-picker orangeBackground",
                              attrs: { href: "#" },
                              on: { click: _vm.countryListPickerCloseButton },
                            },
                            [_vm._v(_vm._s(_vm.$t("common.bck")))]
                          ),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "picker-modal-inner scrollablePicker" },
                      [
                        _c("f7-searchbar", {
                          attrs: {
                            id: "searchCountry",
                            "cancel-link": "Cancel",
                            "search-list": ".countryList",
                            placeholder: "Search",
                          },
                          on: {
                            "searchbar:search": _vm.onSearch,
                            "searchbar:clear": _vm.onClear,
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "list-block countryList" },
                          [
                            _c(
                              "f7-list",
                              {
                                staticClass: "countryList",
                                attrs: { contacts: "" },
                              },
                              _vm._l(
                                _vm.filteredCountries,
                                function (group, key) {
                                  return _c(
                                    "f7-list-group",
                                    { key: key },
                                    [
                                      _c("f7-list-item", {
                                        attrs: {
                                          title: key,
                                          "group-title": "",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _vm._l(group, function (country) {
                                        return _c(
                                          "li",
                                          { attrs: { value: country } },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "label-radio item-content",
                                                on: {
                                                  click:
                                                    _vm.countryListPickerCloseButton,
                                                },
                                              },
                                              [
                                                _c("input", {
                                                  attrs: {
                                                    type: "radio",
                                                    name: "countryPickerRadio",
                                                  },
                                                  domProps: { value: country },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "item-inner" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "item-title",
                                                      },
                                                      [_vm._v(_vm._s(country))]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      }),
                                    ],
                                    2
                                  )
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ]),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }